import { Component, output, input } from '@angular/core';

import { AvailableIcons, ApIconComponent } from '@ap/icon';

/**
 * @ngdoc component
 * @name ApIconButtonLinkComponent
 * @module ApIconButtonLinkModule
 * @description A component a link with an icon
 */
@Component({
    selector: 'ap-icon-button-link',
    templateUrl: './icon-button-link.component.html',
    styleUrls: ['./icon-button-link.component.scss'],
    imports: [ApIconComponent]
})
export class ApIconButtonLinkComponent {
    /**
     * Required - The icon to display
     */
    public readonly iconName = input.required<AvailableIcons>();

    /**
     * The size of the icon. Defaults to `medium`
     */
    public readonly iconSize = input('medium');

    /**
     * Emits event on click of button
     */
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    public readonly onClick = output<Event>();
}
